// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"68772980","455":"94a72e48"}[chunkId] + ".chunk.js";
};